export default __webpack_public_path__ + "static/Plots0053-9d4b3353a2e2b2714e1f7b212d4f40c5.jpg";